import api from "../../index";

export const GetAllDepositRequestApi = (params) => api.get(`wallet/get-all-deposit-request?${params}`);
export const AcceptRejectDepositRequestApi = (data) => api.post('wallet/approved-reject-deposit-request', data);